import { useEffect, useState } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import { atualizarCampoConfig, ouvirClinica } from '@/services/clinicasService';
import { NOME_GENERICO, nomeDoSistema } from '@/lib/sistemaDaClinica';

/**
 * ★ VX — Configurações → Clínica: o NOME DO SISTEMA DE GESTÃO da clínica
 * (`config.nomeSistemaGestao`). O OdontoSDR é vendido para clínicas que não usam
 * Careflow: nenhuma tela leva a marca fixa — quem lê a config decide o rótulo
 * ("Código no {nome}", "Importar do {nome}", "confira se está como no {nome}").
 * Vazio → "sistema da clínica". Nomes de campo (`codigoCareflow`), ids, rotas e
 * textos já gravados NÃO mudam com esta configuração — é só prosa de tela.
 */
export default function SecaoClinica() {
  const { clinicaId } = useAuth();
  const [clinica, setClinica] = useState(null);
  const [nome, setNome] = useState('');
  const [erro, setErro] = useState(null);
  const [salvo, setSalvo] = useState(false);
  const [ocupado, setOcupado] = useState(false);

  useEffect(() => {
    if (!clinicaId) return undefined;
    return ouvirClinica(clinicaId, setClinica, () => setErro('Não foi possível carregar a configuração.'));
  }, [clinicaId]);

  const config = clinica?.config ?? null;
  useEffect(() => {
    setNome(typeof config?.nomeSistemaGestao === 'string' ? config.nomeSistemaGestao : '');
    setSalvo(false);
  }, [config]);

  async function salvar(evento) {
    evento.preventDefault();
    setErro(null);
    setOcupado(true);
    try {
      // Grava o texto limpo; vazio volta ao genérico em todas as telas.
      await atualizarCampoConfig(clinicaId, 'nomeSistemaGestao', nome.trim());
      setSalvo(true);
    } catch (e) {
      setErro(e?.code === 'permission-denied' ? 'Só o gestor altera os dados da clínica.' : (e.message ?? 'Não foi possível salvar.'));
    } finally {
      setOcupado(false);
    }
  }

  if (!clinica) return <p className="vazio">Carregando a configuração…</p>;

  const exemplo = nomeDoSistema({ nomeSistemaGestao: nome });

  return (
    <section className="secao" data-secao="clinica">
      <h2 className="secao-titulo">Clínica</h2>
      <p className="secao-ajuda">
        O nome do sistema de gestão que a clínica usa (agenda, prontuário, contas a receber). Aparece nas telas
        como "Código no {exemplo}" e "Importar do {exemplo}". Em branco, as telas dizem "{NOME_GENERICO}".
      </p>
      <form className="formulario" onSubmit={salvar}>
        <div className="campo">
          <label htmlFor="cl-nome-sistema">Nome do sistema de gestão</label>
          <input
            id="cl-nome-sistema"
            value={nome}
            maxLength={40}
            placeholder={NOME_GENERICO}
            onChange={(e) => { setNome(e.target.value); setSalvo(false); }}
          />
        </div>
        <div className="dialogo-acoes">
          {erro && <p className="erro">{erro}</p>}
          {salvo && <span className="indicador-nota">Salvo.</span>}
          <button type="submit" className="btn-primario" disabled={ocupado}>
            {ocupado ? 'Salvando…' : 'Salvar'}
          </button>
        </div>
      </form>
    </section>
  );
}
